import React from 'react'

import { useArchiveTemplateMutation } from '../../../../generated/graphql'
import useModal from '../../../../lib/hooks/useModal'
import useNotification from '../../../../lib/hooks/useNotification'
import { ConfirmArchiveTemplateModal } from '../../templateModals'

type ConfirmArchiveTemplateModalWrapperProps = {
  /** ID of Plan */
  id: string
  /** Determines visibility of modal */
  isOpen: boolean
}

const ConfirmArchiveTemplateModalWrapper = ({
  id,
  isOpen
}: ConfirmArchiveTemplateModalWrapperProps) => {
  const { hideModal } = useModal()
  const { showErrorNotif } = useNotification()

  const [archivePlan, mutation] = useArchiveTemplateMutation({
    variables: { input: id },
    onError: () => {
      hideModal()
      showErrorNotif('Template could not be archived.', archivePlan)
    }
  })

  const onConfirm = () => {
    hideModal()
    archivePlan()
  }

  if (!mutation.called) {
    return <ConfirmArchiveTemplateModal isOpen={isOpen} onConfirm={onConfirm} label="Template" />
  }

  return null
}

export default ConfirmArchiveTemplateModalWrapper
